var React = require('react');

function SocialTwitterOld (props) {
    return React.createElement("svg",props,[React.createElement("title",{"key":0},"Twitter"),React.createElement("g",{"key":1},React.createElement("g",null,React.createElement("path",{"d":"M22.5,3.1c1-0.1,2.1-0.4,3-0.8c-0.7,1-1.6,2-2.6,2.7v0.7c0,8.2-6.6,14.9-14.8,14.9c0,0,0,0,0,0H8\n\t\t\tc-2.8,0-5.6-0.8-8-2.4c0.4,0,0.8,0.1,1.2,0.1c2.4,0,4.6-0.8,6.5-2.2c-2.2,0-4.2-1.5-4.9-3.6c0.3,0.1,0.7,0.1,1,0.1\n\t\t\tc0.5,0,0.9-0.1,1.4-0.2C2.8,11.9,1,9.8,1,7.3V7.2c0.7,0.4,1.6,0.6,2.4,0.7c-1.5-1-2.3-2.6-2.3-4.4c0-0.9,0.2-1.8,0.7-2.6\n\t\t\tc2.6,3.3,6.6,5.3,10.8,5.5c-0.1-0.4-0.1-0.8-0.1-1.2c0-2.8,2.3-5.2,5.1-5.2c0,0,0,0,0,0h0.1c1.5,0,2.9,0.6,3.8,1.7\n\t\t\tc1.2-0.2,2.3-0.7,3.3-1.3C24.4,1.6,23.6,2.5,22.5,3.1z"})))]);
}

SocialTwitterOld.defaultProps = {"version":"1.1","x":"0px","y":"0px","viewBox":"0 0 25.5 20.6","style":{"enableBackground":"new 0 0 25.5 20.6"},"xmlSpace":"preserve"};

module.exports = SocialTwitterOld;

SocialTwitterOld.default = SocialTwitterOld;
